import {
  SET_ASSESSMENT_QUESTIONS,
  IS_LOADING,
  SET_ASSESSMENT_REPORT,
} from "./constants";

const initialState = {
  assessmentQuestions: {},
  isLoading: false,
  assessmentReport: {},
};

/**
 * Define the reducer with actions
 *
 * @param {Object} state
 * @param {Object} action
 */
function AssessmentReducer(state = initialState, action) {
  switch (action.type) {
    case SET_ASSESSMENT_QUESTIONS:
      return {
        ...state,
        assessmentQuestions: action.data,
      };

    case SET_ASSESSMENT_REPORT:
      return {
        ...state,
        assessmentReport: action.data,
      };

    case IS_LOADING:
      return {
        ...state,
        isLoading: action.data,
      };

    default:
      return state;
  }
}

export default AssessmentReducer;
